import { render, staticRenderFns } from "./brief_training_report.vue?vue&type=template&id=4af2f55d&scoped=true"
import script from "./brief_training_report.vue?vue&type=script&lang=js"
export * from "./brief_training_report.vue?vue&type=script&lang=js"
import style0 from "./brief_training_report.vue?vue&type=style&index=0&id=4af2f55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2f55d",
  null
  
)

export default component.exports